import { render, staticRenderFns } from "./ImportData.vue?vue&type=template&id=f96c753e&"
import script from "./ImportData.vue?vue&type=script&lang=ts&"
export * from "./ImportData.vue?vue&type=script&lang=ts&"
import style0 from "./ImportData.vue?vue&type=style&index=0&id=f96c753e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports